/**
 * Maximum chapter title length
 */
export const MAX_CHAPTER_TITLE_LENGTH = 255

/**
 * Maximum chapter description length
 */
export const MAX_CHAPTER_DESCRIPTION_LENGTH = 5000

/**
 * Minimum estimated hours
 */
export const MIN_ESTIMATED_HOURS = 0.5

/**
 * Maximum estimated hours
 */
export const MAX_ESTIMATED_HOURS = 150

/**
 * Error messages
 */
export const CHAPTER_ERRORS = {
  NOT_FOUND: 'Chapitre non trouvé',
  NOT_ACCESSIBLE: 'Chapitre non accessible',
  INVALID_STATUS: 'Statut de chapitre invalide',
  INVALID_PERIOD: 'Période académique invalide',
  INVALID_DATE_FORMAT: 'Format de date invalide (attendu: YYYY-MM-DD)',
  INVALID_DATE_RANGE: 'La date de fin doit être postérieure à la date de début',
  CREATION_FAILED: 'Erreur lors de la création du chapitre',
  UPDATE_FAILED: 'Erreur lors de la mise à jour du chapitre',
  DELETE_FAILED: 'Erreur lors de la suppression du chapitre',
  ALREADY_DELETED: 'Ce chapitre a déjà été supprimé',
  HAS_LESSONS: 'Impossible de supprimer un chapitre contenant des leçons',
} as const

/**
 * Success messages
 */
export const CHAPTER_SUCCESS = {
  CREATED: 'Chapitre créé avec succès',
  UPDATED: 'Chapitre mis à jour avec succès',
  DELETED: 'Chapitre supprimé avec succès',
} as const

/**
 * Default chapter status codes
 */
export const CHAPTER_STATUS_CODES = {
  DRAFT: 'draft',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  ARCHIVED: 'archived',
} as const

export const CHAPTER_OPERATIONS = {
  CREATE: 'create_chapter',
  FIND_ALL: 'findMany_chapters',
  FIND_ONE: 'findOne_chapter',
  UPDATE: 'update_chapter',
  DELETE: 'delete_chapter',
  SET_STATE: 'setState_chapter',
  SET_VISIBILITY: 'setVisibility_chapter',
  LIST_LESSONS: 'listLessons_chapter',
} as const

/**
 * Messages de log pour les opérations chapitre
 */
export const CHAPTER_LOG_MESSAGES = {
  CREATING: (userId: string, title: string) =>
    `[User ${userId}] Creating chapter: ${title}`,
  CREATED: (id: string) => `Chapter created successfully: ${id}`,
  UPDATING: (userId: string, id: string) =>
    `[User ${userId}] Updating chapter: ${id}`,
  UPDATED: (id: string) => `Chapter updated successfully: ${id}`,
  DELETING: (userId: string, id: string) =>
    `[User ${userId}] Deleting chapter: ${id}`,
  DELETED: (id: string) => `Chapter deleted successfully: ${id}`,
  STATE_CHANGED: (id: string, state: string, userId: string) =>
    `Chapter ${id} state changed to ${state} by user ${userId}`,
  VISIBILITY_CHANGED: (id: string, visibility: string, userId: string) =>
    `Chapter ${id} visibility changed to ${visibility} by user ${userId}`,
  FOUND: (count: number, total: number, userId: string) =>
    `Found ${count}/${total} chapters for user ${userId}`,
} as const

/**
 * Messages d'erreur pour ServiceErrorHandler
 */
export const CHAPTER_ERROR_CONTEXTS = {
  CREATE: 'create chapter',
  FETCH_ALL: 'fetch chapters with cursor',
  FETCH_ONE: 'fetch chapter',
  UPDATE: 'update chapter',
  DELETE: 'delete chapter',
  SET_STATE: 'set chapter state',
  SET_VISIBILITY: 'set chapter visibility',
  LIST_LESSONS: 'list chapter lessons',
} as const

/**
 * Actions PolicyEngine
 */
export const CHAPTER_POLICY_ACTIONS = {
  CREATE: 'chapter:create',
  VIEW: 'chapter:view',
  UPDATE: 'chapter:update',
  DELETE: 'chapter:delete',
  SET_STATE: 'chapter:setState',
  SET_VISIBILITY: 'chapter:setVisibility',
  CREATE_LESSON: 'chapter:createLesson',
} as const
